import { render, staticRenderFns } from "./MarkStockInfoBase.vue?vue&type=template&id=1ec43290&scoped=true"
import script from "./MarkStockInfoBase.vue?vue&type=script&lang=js"
export * from "./MarkStockInfoBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec43290",
  null
  
)

export default component.exports